import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2023 semantics GmbH
//  Date      : $Date: 2026-05-27 14:18:05 +0200 (Wed, 27 May 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 163319 $
//  Purpose   : tagclouds (legacy /nav/index/cloud)
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import { sorted } from 'ldash';
import { useState, useDelay, useApi, useInView } from 'uix/hooks';
// ---Local imports
import { Link } from './links';
// ---Exports
const FONTSIZE = {
    1: 80,
    2: 90,
    3: 100,
    4: 115,
    5: 150
};
const buildLink = ({ type, caption, name, toLegacy })=>{
    // /nav/cloud/name?query=Blaas%2C%20Leo
    if (toLegacy) {
        return /*#__PURE__*/ _jsx(Link, {
            classname: "nav",
            tabname: "cloud",
            id: type,
            query: {
                query: name
            },
            external: true,
            target: "cloud",
            children: caption || name
        });
    } else {
        return /*#__PURE__*/ _jsx(Link, {
            children: name
        });
    }
};
export const TagCloud = ({ type = 'name', hoverEffect = false, className, toLegacy = false })=>{
    let [ref, inView] = useInView({
        triggerOnce: true
    });
    let { data } = useApi('filter/getTagCloud', {
        id: type
    }, {
        condition: inView
    });
    let terms = data?.terms || [];
    terms = sorted(terms, ({ name })=>name).map(({ name, caption, count, size })=>/*#__PURE__*/ _jsxs("span", {
            className: className,
            title: `Einträge im Index: ${count}`,
            style: {
                display: 'inline-block',
                fontSize: `${FONTSIZE[size] ?? 100}%`
            },
            children: [
                buildLink({
                    type,
                    caption,
                    name,
                    toLegacy
                }),
                ' '
            ]
        }, name));
    return /*#__PURE__*/ _jsx("div", {
        ref: ref,
        children: terms
    });
};
